import React from "react";
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default class DownloadExcelComponent extends React.Component {

    render() {
        return (
            <>
                <ExcelFile
                    element={
                        <>
                            <button className="btn bg-light-blue btn-sm"><span className="text-blue fw-bold "><i className="fs-7 fi-rr-download text-blue fw-bold "></i>  Descargar</span></button>
                        </>
                    }
                    filename={this.props.fileNameDownload}>
                    <ExcelSheet dataSet={setDataShet(this.props.columns, this.props.data, this.props.fileNameDownload)} name="Hoja1" />
                </ExcelFile>
            </>
        )
    }
}

function setDataShet(columns, data, fileName) {
    let dataShet = [[]];
    let indx = 0;
    const accessors = []
    const isSalesComparison = fileName.includes('Comparativo de Ventas')
    if (columns)
        if(isSalesComparison) {
            let indx = 1;
            dataShet = [[' ', ' ', ' ', ' ']];
            dataShet.push([])
            columns.forEach(element => {
                if (typeof element.Header === 'string' && element.columns) {
                    dataShet[0].push(' ')
                    dataShet[0].push(element.Header)
                    dataShet[0].push(' ')
                    element.columns.forEach(subElement => {
                        dataShet[1].push({
                            value: subElement.Header,
                            style: { font: { bold: true } }
                        })
                        accessors.push(subElement.accessor)
                    })
                } else if(typeof element.Header === 'string' && !element.columns) {
                    dataShet[1].push({
                        value: element.Header,
                        style: { font: { bold: true } }
                    })
                    accessors.push(element.accessor)
                }
            })

            if (data) {
                data.forEach(elementData => {
                    indx++;
                    dataShet.push([]);
                    if (accessors) accessors.forEach(accessor => {
                        dataShet[indx].push(elementData[accessor]);
                    });
                });
            }
        } else {
            columns.forEach(element => {
                if (typeof element.Header === 'string') dataShet[0].push(element.Header)
                else {
                    if (typeof element.Header === 'object') {
                        let headerTemp = '';
                        element.Header.props.children.forEach(child => {
                            if (typeof child === 'string' || child === parseInt(child, 10)) headerTemp += child.toString();
                            else
                                if (typeof child.props === 'object')
                                    if (typeof child.props.children === 'string' || child.props.children === parseInt(child.props.children, 10))
                                        headerTemp += child.props.children.toString();
                        });
                        dataShet[0].push(headerTemp);
                    }
                }
            });

            if (data) {
                data.forEach(elementData => {
                    indx++;
                    dataShet.push([]);
                    if (columns) columns.forEach(elementColumn => {
                        dataShet[indx].push(elementData[elementColumn.accessor]);
                    });
                });
            }
        }

    return [{
        "columns": dataShet[0],
        "data":  dataShet.slice(1),
        }
    ];
}